import { jsx as _jsx } from "react/jsx-runtime";
const EmptyComponent = () => /*#__PURE__*/_jsx("div", {});
EmptyComponent.displayName = 'EmptyComponent';
export default EmptyComponent;